<template>
  <tr>
    <td class="koumoku reportCont cwC_1">
      <select v-model="item.c_report_det_type">
        <option
          v-for="option in opType"
          v-bind:value="option.code"
          v-bind:key="option.code"
        >
          {{ option.label }}
        </option>
      </select>
      <!-- <vSelect
        :options="opType"
        v-model="item.c_report_det_type"
        :reduce="(label:any) => label.code"
        class="drtype"
      ></vSelect>-->
    </td>

    <td class="suuryou reportCont cwC_2">
      <input type="text" class="" v-model="item.c_report_det_project_name" />
    </td>
    <td class="suuryou reportCont cwC_3">
      <input type="text" class="" v-model="item.c_report_det_visited_name" />
    </td>
    <td class="tanka reportCont cwC_4">
      <input type="text" class="" v-model="item.c_report_det_location" />
    </td>
    <td class="kingaku reportCont cwC_5">
      <input type="text" class="" v-model="item.c_report_det_work_contents" />
    </td>
    <td class="syouhizei reportCont cwC_6 selectedClear selectBorderNone">
      <input type="text" class="" v-model="item.c_report_det_sales" />
    </td>
    <td class="zeikomi reportCont cwC_7">
      <input type="text" class="" v-model="item.c_report_det_supply" />
    </td>
    <!-- <td class="zeikomi reportCont cwC_6">
      <input
        type="text"
        style="text-align: left"
        class=""
        v-model="item.c_claim_det_remarks"
      />
    </td> -->
  </tr>
</template>
<script lang="ts">
import { Prop, Options, Vue, Watch } from "vue-property-decorator";
import { EntityClaimDet } from "furukawa-common/src/common/entity/EntityClaimDet";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  CONST_OP_DAILYREPORT_TYPE,
  CONST_OP_TAXRATE,
} from "furukawa-common/src/common/constant/Constants";
import { EntityReportDet } from "furukawa-common/src/common/entity/EntityReportDet";

@Options({
  components: {
    vSelect,
  },
})
export default class Mo_dailyReport_row extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  @Prop({ required: true })
  item: EntityReportDet;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  opType = CONST_OP_DAILYREPORT_TYPE;
  //----------------------
  //モーダル用プロパティ
  //----------------------

  //----------------------
  //制御用メソッド
  //----------------------
  // async mounted() {}

  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * 金額セル入力時の処理
   * カンマを消す
   * @param obj
   */
  kanmaDel(obj: any) {
    // //カンマを消す
    obj.target.value = obj.target.value.replace(/,/g, "");
    if (obj.target.value == "0") obj.target.value = "";
  }
  /**
   * 金額セル入力時の処理
   * カンマを付ける
   * @param obj
   */
  kanmaIns(obj: any) {
    let val: string = obj.target.value;

    //うっかり入力しているかもしれないカンマを消す
    val = val.replace(/,/g, "");
    //整数に変換したのち文字列に戻す
    //この時点で数字とマイナス記号だけが残る
    let num = "" + parseInt(val);
    //正規表現で桁区切りするための良く見かける関数的な何か
    //変数 num の中身が、桁区切りされる
    while (num != (num = num.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
    //numに入っている値が数値じゃないときは空白とする
    if (isNaN(parseInt(num))) num = "";
    //桁区切りした結果（変数 num）でテキストボックスの中身を書き換える
    obj.target.value = num;
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>
<style scoped>
td {
  border-left: 1px solid #dfdfdf;
}
.cwC_6 {
  border-right: 1px solid #dfdfdf;
}
.reportCont > input,
.reportCont > select {
  width: 100%;
  height: 30px;
  border: none;
  text-align: left;
}
</style>
